import apiClient from "@/api-client";
import { useQuery } from "@tanstack/react-query";

export const dashboardKeys = {
  all: ['dashboard'] as const,
};

export function useDashboardStats() {
  return useQuery({
    queryKey: dashboardKeys.all,
    queryFn: async () => {
      const response = await apiClient.get(`/conversations/dashboard-statistics`);
      return response.data;
    },
    refetchOnMount: 'always',
  });
}